import { reskinStyles } from 'core/components/theme/theme-variant';
import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  drawerPaper: ({ footerHeight }) => ({
    width: 400,
    backgroundColor: theme.colorPalette.beige_25,
    top: theme.sizes.headerHeight,
    bottom: footerHeight,
    height: 'auto',
    position: 'fixed'
  }),
  drawerContent: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%'
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(5, 4),
    borderBottom: `1px solid ${theme.colorPalette.beige_50}`,
    position: 'sticky',
    top: 0,
    backgroundColor: theme.colorPalette.beige_25
  },
  policyLevelAdjustor: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(5, 4),
    borderBottom: `1px solid ${theme.colorPalette.beige_50}`,
    position: 'sticky',
    top: 0,
    backgroundColor: theme.colorPalette.beige_25,
    zIndex: 1,
    gap: theme.spacing(2)
  },
  headerRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%'
  },
  notification: {
    padding: theme.spacing(4),
    margin: theme.spacing(2)
  },
  label: {
    marginBottom: 0
  },
  scrollableContent: {
    flex: 1,
    overflowY: 'auto'
  },
  location: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(4),
    borderBottom: `1px solid ${theme.colorPalette.beige_50}`,
    gap: theme.spacing(0)
  },
  risk: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    gap: theme.spacing(2),
    padding: theme.spacing(1, 0)
  },
  navigateButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flex: 1,
    textAlign: 'left',
    padding: theme.spacing(1, 2, 0, 2),
    ...reskinStyles(theme, { padding: theme.spacing(1, 3) }),
    '&:hover': {
      backgroundColor: theme.colorPalette.orange_50_op_10,
      ...reskinStyles(theme, { backgroundColor: theme.colorPalette.beige_50 }),
      '& $hoverText': {
        display: 'flex',
        marginLeft: theme.spacing(1)
      }
    }
  },
  riskDescription: {
    display: 'block',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    flex: 1,
    minWidth: 0
  },
  topMargin: {
    marginTop: theme.spacing(4)
  },
  headerTopMargin: {
    marginTop: theme.spacing(5)
  },
  hoverText: {
    display: 'none',
    alignItems: 'center',
    color: theme.colors.action_text
  },
  arrowIcon: {
    marginLeft: theme.spacing(1)
  },
  adjustmentField: {
    minHeight: 'unset'
  },
  noPadding: {
    padding: 0
  },
  labelContainer: {
    height: 'unset'
  },
  rationaleRow: {
    width: '100%',
    marginTop: theme.spacing(1)
  }
});

export default makeStyles(styles);
